<template>
  <div class='myaudio'>
    <div class = "icon-wrap">
      <Icon :disabled = 'src' @click = "_play" size = "20" class = 'click-icon' v-if = "!playing" type = "md-play" />
      <Icon @click = "_play" size = "20" class = 'click-icon' v-else type = "md-pause" />
    </div>
    <div class = "process-wrap">
      <Slider show-tip = "never" @on-input = "processChangeing" @on-change = "processChange" v-model="process" :step="1" :max = "1000"></Slider>
    </div>
    <div class = "time-wrap">
      {{currentTime|time}}
      <span>/</span>
      {{duration|time}}
    </div>
    <div class = "speed-wrap">
      <Dropdown  trigger="click" @on-click = "speedChange">
        <a href="javascript:void(0)">
            倍速
            <Icon type="ios-arrow-down"></Icon>
        </a>
        <DropdownMenu slot="list">
            <DropdownItem name = "2" :class = '{activecolor:(speed == 2)}'>2.0</DropdownItem>
            <DropdownItem name = "1.5" :class = '{activecolor:(speed == 1.5)}'>1.5</DropdownItem>
            <DropdownItem name = "1" :class = '{activecolor:(speed == 1)}'>1.0</DropdownItem>
            <DropdownItem name = "0.5" :class = '{activecolor:(speed == 0.5)}'>0.5</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class = "voice-wrap" @mouseenter="(voiceSetShow = true)" @mousemove="(voiceSetShow = true)" @mouseleave="(voiceSetShow = false)">
      <Poptip padding = "0px 0px"  placement="top" trigger="hover" width = "160" :transfer = "true">
        <Icon @click = 'doMute' v-if = "!voice" class = 'click-icon' type="md-volume-off" size = "20" />
        <Icon @click = 'doMute' v-if = "voice" class = 'click-icon' type="md-volume-down" size = "20" />
        <div slot = "content">
          <div style = "width:160px;padding:0 16px;" v-show = "true">
            <Slider @on-input = "voiceChange" :max = "10" v-model="voice" :step="1"></Slider>
          </div>
        </div>
      </Poptip>
      <!-- <div class = 'voice-set-wrap'>
        <transition name="fades">
          <div class = 'voice-set' v-show = "voiceSetShow">
            <Slider @on-input = "voiceChange" :max = "10" v-model="voice" :step="1"></Slider>
          </div>
        </transition>
      </div> -->
    </div>
    <div class = "download-wrap">
      <a :href = "downUri||src" class = 'click-icon' :download = "filename?filename:'未命名文件'">
        <Icon @click = "_download" class = 'click-icon' size = "20" type="md-download" />
      </a>
    </div>
  </div>
</template>
<script>
import { clearInterval } from 'timers';
export default {
  props: {
    src: String,
    filename: String,
    downUri: String
  },
  data(){
    return {
      playing: false,
      process: 0,
      isMute: false,
      voiceSetShow: false,
      voice: 5,
      speed: 1,
      audioCtx: null,
      duration: 0,
      currentTime: 0,
      isProcessChanging: false,
      catchVoice: 5
    }
  },
  created(){
    if(this.src){
      this.initAudio(this.src)
    }
  },
  watch: {
    src(val){
      if(this.audioCtx){
        return
      }else if(val){
        this.src = val
        this.initAudio(this.src)
      }
    }
  },
  mounted() {
  },
  filters: {
    time(e){
      if(e === Infinity){
        return '--:--'
      }
      e = Number(e)
      let min,sec
      sec = e%60
      if(e>60){
        min = (e-sec)/60
      }else{
        min = 0
      }
      sec = Number(sec).toFixed(0)
      sec = sec<10?`0${sec}`:sec
      min = min<10?`0${min}`:min
      return `${min}:${sec}`
    }
  },
  beforeDestroy(){
    this.playing = false
  },
  destroyed() {
    // console.log("<Audio>进入destroyed")
    this.removeAudio()
    if(this._timer){
      // clearInterval(this._timer)
    }
  },
  methods:{
    removeAudio(){
      if(this.audioCtx){
        document.body.removeChild(this.audioCtx);
      }
    },
    initAudio(src){
      this.audioCtx = document.createElement('audio')
      this.audioCtx.src = src
      this.audioCtx.style.display = 'none'
      this.process = 0
      this.speed = this.audioCtx.playbackRate
      this.voice = this.audioCtx.volume*10
      document.body.appendChild(this.audioCtx)
      // this.audioCtx.onload = ()=>{
      //   this.duration = this.audioCtx.duration
      // }
      // this.duration = this.audioCtx.duration
      this.getDuration()
    },
    getDuration(){
      if(!this.audioCtx){
        return
      }
      if(this.audioCtx.duration&&this.audioCtx.duration!==Infinity){
        this.duration = this.audioCtx.duration;
        console.log("this.duration",this.duration)
      }else{
        this._timer = setTimeout(() => {
          this.getDuration()
        },1000)
      }
    },
    pause(){
      this._play(1)
    },
    _play(isPause){
      if(isPause == 1){
        this.playing = false
        this.audioCtx.pause()
        return
      }
      if(!this.audioCtx || this.audioCtx.readyState!=4){
        this.$Message.warning('音频尚未就绪')
        return
      }
      this.audioCtx&&(this.duration = this.audioCtx.duration || 0)
      if(!this.playing){
        this.audioCtx.play()
        this.playing = true
        this.voiceProcess()
      }else{
        this.playing = false
        this.audioCtx.pause()
      }
    },
    voiceProcess(){
      this.currentTime = this.audioCtx.currentTime
      let duration = (this.audioCtx.duration&&this.audioCtx.duration!==Infinity)?this.audioCtx.duration : this.currentTime
      this.process = Number(this.audioCtx.currentTime/duration).toFixed(2)*1000
      if(this.audioCtx.ended){
        this.playing = false
      }
      if(!this.audioCtx || !this.playing || this.audioCtx.ended || this.audioCtx.paused){
        return
      }
      setTimeout(() => {
        this.voiceProcess()
      },200)
    },
    processChange(val){
      this.audioCtx.currentTime = (val/1000)*this.audioCtx.duration
      this.currentTime = this.audioCtx.currentTime
    },
    processChangeing(val){
    },
    voiceChange(val){
      this.voice = val
      this.audioCtx.volume = this.voice/10
    },
    speedChange(speed){
      this.speed = Number(speed)
      this.audioCtx.playbackRate = this.speed
    },
    doMute(){
      if(this.voice){
        this.catchVoice = this.voice
        this.voiceChange(0)
      }else{
        this.voiceChange(this.catchVoice)
      }
    },
    _download(){
      // var a = document.createElement("a")
      // a.setAttribute("href", this.audioCtx.currentSrc)
      // a.setAttribute("target", "_blank")
      // document.body.appendChild(a)
      // a.click()
    }
  },
  components: {}
}
</script>
<style scoped lang = "less">
.myaudio{
  padding:0px 20px;
  border:1px solid #ccc;
  display: flex;
  line-height:34px;
  border-radius: 24px;
  .click-icon{
    color:#666;
    cursor: pointer;
    &:hover{
      color: #04cbdb;
    }
  }
  .time-wrap{
    padding-left:10px;
  }
  .icon-wrap{
    width:30px;
    line-height:34px;
    padding-right:5px;
  }
  .process-wrap{
    flex:3;
  }
  .voice-wrap{
    padding-left:10px;
    line-height:34px;
    position:relative;
    .voice-set-wrap{
      position:absolute;
      left:-85px;
      bottom:75px;
    }
    .voice-set{
      position:fixed;
      padding:0 20px;
      background:#fff;
      border:1px solid #ddd;
      width:160px;
      border-radius: 18px;
      /* bottom:30px; */
    }
  }
  .download-wrap{
    padding-left:5px;
  }
  .speed-wrap{
    padding-left:5px;
    font-size:14px;
    position: relative;
  }
}
.activecolor{
  color: #04cbdb;
}
.fades-enter-active, .fades-leave-active {
    transition: opacity 0.5s
}
.fades-enter, .fades-leave-to {
    opacity: 0
}
.fades-leave, .fades-enter-to {
  opacity: 1
}
</style>